import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f5b23c3")

_pushScopeId("data-v-4f5b23c3")
const _hoisted_1 = { class: "card" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.$slots.header)
      ? _renderSlot(_ctx.$slots, "header", { key: 0 })
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.$slots.footer)
      ? _renderSlot(_ctx.$slots, "footer", { key: 1 })
      : _createCommentVNode("", true)
  ]))
})